import { render, staticRenderFns } from "./EmbedSlideConfig.vue?vue&type=template&id=c6d3d0f8&scoped=true"
import script from "./EmbedSlideConfig.vue?vue&type=script&lang=js"
export * from "./EmbedSlideConfig.vue?vue&type=script&lang=js"
import style0 from "./EmbedSlideConfig.vue?vue&type=style&index=0&id=c6d3d0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d3d0f8",
  null
  
)

export default component.exports